import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export type ApplicationBranchFormMode = 'create' | 'edit';

export interface IApplicationBranchFormComponentInParams {
  title: string;
  description: string;
  mode?: ApplicationBranchFormMode;
}
@Component({
    selector: 'app-application-branch-form',
    templateUrl: './application-branch-form.component.html',
    standalone: false
})
export class ApplicationBranchFormComponent {
  constructor(
    private dialogRef: MatDialogRef<ApplicationBranchFormComponent>,
    @Inject(MAT_DIALOG_DATA) public params: IApplicationBranchFormComponentInParams,
  ) {
  }

  get headerTitle(): string {
    return this.params.mode === 'edit' ? 'Branch settings' : 'Create feature branch';
  }

  get submitLabel(): string {
    return this.params.mode === 'edit' ? 'Save' : 'Create';
  }

  onSubmitClicked() { this.dialogRef.close(this.params); }
  onCancelClicked() { this.dialogRef.close(null); }
}
